<div class="bgf-auto-selector">
    <input 
        type="text"
        class="input"
        [placeholder]="placeholder"
        [(ngModel)]="selectedInstance"
        (ngModelChange)="onChange($event)"
        (blur)="onTouched()"
        [matAutocomplete]="auto"
        (afterValueChanged)="fetchInstances()"
    >
    <i class="clear-btn fa-solid fa-circle-xmark" *ngIf="selectedInstance" (click)="writeValue(null); onOptionSelected(null)"></i>
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn.bind(this)" (optionSelected)="onOptionSelected($event)">
        <mat-option *ngIf="fetchingInstances" class="bgf-loading bgf-loading--color"></mat-option>
        <ng-container *ngIf="!fetchingInstances && instanceType === 'component'">
            @for (component of instanceList; track component.id) {
                <mat-option [value]="component">{{component.game?.name}} - {{component.name}} - {{component.sku}}</mat-option>
            }
        </ng-container>
        <ng-container *ngIf="!fetchingInstances && instanceType === 'game'">
            @for (game of instanceList; track game.id) {
                <mat-option [value]="game">{{game.name}}</mat-option>
            }
        </ng-container>
        <ng-container *ngIf="!fetchingInstances && instanceType === 'material'">
            @for (material of instanceList; track material.id) {
                <mat-option [value]="material">{{material.name}}</mat-option>
            }
        </ng-container>
        <ng-container *ngIf="!fetchingInstances && instanceType === 'product-group'">
            @for (productGroup of instanceList; track productGroup.id) {
                <mat-option [value]="productGroup">{{productGroup.name}}</mat-option>
            }
        </ng-container>
        <ng-container *ngIf="!fetchingInstances && instanceType === 'product-group' && instanceList.length === 0">
            <div class="bgf-auto-selector-add-new-instance">
                <button class="button is-primary is-outlined">Hozzáad</button>
            </div>            
        </ng-container>
    </mat-autocomplete>
</div>
